module.exports = __webpack_public_path__ + "static/media/bell.1769eddf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/bell.mp3
// module id = 374
// module chunks = 0